import { RouteErrorMap } from '../types/iloq-booking-api';

export const routeErrorMessages: RouteErrorMap = {
  // Bookings routes
  'GET /v2/bookings/user': {
    description: 'Hämta användarens bokningar',
    errors: [
      { code: 200, message: 'Användarens bokningar hämtades framgångsrikt' },
      { code: 400, message: 'Ogiltiga sökparametrar angavs' },
      {
        code: 401,
        message: 'Du måste vara inloggad för att se dina bokningar',
      },
      { code: 403, message: 'Du har inte behörighet att se dessa bokningar' },
      { code: 404, message: 'Användaren kunde inte hittas' },
      {
        code: 500,
        message: 'Ett internt serverfel uppstod vid hämtning av bokningar',
      },
    ],
  },
  'GET /v2/bookings': {
    description: 'Hämta alla bokningar',
    errors: [
      { code: 200, message: 'Bokningarna hämtades framgångsrikt' },
      { code: 400, message: 'Ogiltiga sökparametrar angavs' },
      { code: 401, message: 'Du måste vara inloggad för att se bokningar' },
      { code: 403, message: 'Du har inte behörighet att se dessa bokningar' },
      {
        code: 500,
        message: 'Ett internt serverfel uppstod vid hämtning av bokningar',
      },
    ],
  },
  'POST /v2/bookings': {
    description: 'Skapa en ny bokning',
    errors: [
      { code: 201, message: 'Bokningen skapades framgångsrikt' },
      { code: 400, message: 'Ogiltig bokningsinformation angavs' },
      { code: 401, message: 'Du måste vara inloggad för att skapa en bokning' },
      { code: 404, message: 'Nyckeln kunde inte hittas' },
      { code: 403, message: 'Du har inte behörighet att skapa bokningar' },
      {
        code: 409,
        message:
          'Maximalt antal bokningar per användare för denna resurs har uppnåtts',
      },
      {
        code: 500,
        message: 'Ett internt serverfel uppstod vid skapande av bokningen',
      },
    ],
  },
  'DELETE /v2/bookings/:id': {
    description: 'Avboka en bokning',
    errors: [
      { code: 200, message: 'Bokningen avbokades framgångsrikt' },
      { code: 400, message: 'Ogiltigt boknings-ID angavs' },
      { code: 401, message: 'Du måste vara inloggad för att avboka' },
      { code: 403, message: 'Fel nyckel användes för att avboka bokningen' },
      { code: 404, message: 'Nyckeln kunde inte hittas' },
      { code: 500, message: 'Ett internt serverfel uppstod vid avbokning' },
    ],
  },

  // Resources routes
  'GET /v2/resources': {
    description: 'Hämta alla tillgängliga resurser',
    errors: [
      { code: 200, message: 'Resurserna hämtades framgångsrikt' },
      { code: 400, message: 'Ogiltiga sökparametrar angavs' },
      { code: 401, message: 'Du måste vara inloggad för att se resurser' },
      { code: 403, message: 'Du har inte behörighet att se resurser' },
      {
        code: 500,
        message: 'Ett internt serverfel uppstod vid hämtning av resurser',
      },
    ],
  },
  'GET /v2/resources/:id/schema': {
    description: 'Hämta bokningsschema för en resurs',
    errors: [
      { code: 200, message: 'Schemat hämtades framgångsrikt' },
      { code: 400, message: 'Ogiltigt resurs-ID eller kundkod angavs' },
      { code: 401, message: 'Du måste vara inloggad för att se schemat' },
      { code: 403, message: 'Du har inte behörighet att se detta schema' },
      { code: 404, message: 'Resursen eller kunden kunde inte hittas' },
      {
        code: 500,
        message: 'Ett internt serverfel uppstod vid hämtning av schemat',
      },
    ],
  },
};
